import * as React from 'react';
import { DetailsTooltipStyles } from '../../CardView/DetailsTooltipStyles';
import { IContentInfo } from '../../../../ts/models/IContentInfo';

export function doesTooltipNotHaveOwnerToDisplay(content: IContentInfo) {
  return !content || !content.owner || (content.owner.isHiddenInternalUser || !content.owner.displayName);
}

export interface TooltipProps {
  children?: any;
}

export const TooltipTestId = 'details-tooltip';

export function Tooltip(props: TooltipProps) {
  return (
    <div className={DetailsTooltipStyles.DetailsTooltip} data-tb-test-id={TooltipTestId}>
      {props.children}
    </div>
  );
}
